<template>
  <div>

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Показ</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>строка</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Поиск..."
              />
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refOrderListTable"
        class="position-relative"
        :items="fetchOrders"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Ничего не найдено"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: order date -->
        <template #cell(order_date)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.item.order_date }}</span>
          </div>
        </template>

        <!-- Column: msisdn -->
        <template #cell(msisdn)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.item.msisdn }}</span>
          </div>
        </template>

        <!-- Column: price -->
        <template #cell(price)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.item.price }}</span>
          </div>
        </template>

        <!-- Column: fio -->
        <template #cell(fio)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.item.fio }}</span>
          </div>
        </template>

        <!-- Column: phone client -->
        <template #cell(phone_number)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.item.phone_number }}</span>
          </div>
        </template>

        <!-- Column: status -->
        <template #cell(status)="data">
          <div class="text-nowrap">

            <b-badge
              pill
              :variant="`light-${resolveOrderStatusVariant(data.item.status)}`"
              class="text-capitalize"
            >
              {{ statusTranslate[data.item.status] }}
            </b-badge>

          </div>
        </template>

        <!-- Column: View Documents -->
        <template #cell(documents)="data">
          <div class="text-nowrap">
            <b-button
              variant="flat-primary"
              @click="modalShow(data.item.id, data.item)"

            >
              <feather-icon
                icon="EyeIcon"
                class="cursor-pointer mr-25"
              />
              Посмотреть
            </b-button>
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Показано {{ dataMeta.from }} до {{ dataMeta.to }} из {{ dataMeta.of }} строк</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalOrders"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
    <order-doc-modal :id.sync="selectedId" :is-show.sync="isShowModal" :order-item="orderItem" :status-options="statusOptions" :selected-status.sync="selectedStatus" @refresh-table="refetchData"/>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BPagination, BButton, BBadge,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import useOrdersList from './useOrdersList'
import orderDocModal from './OrderDocModal.vue'

export default {
  data() {
    return {
      selectedId: 0,
      isShowModal: false,
      orderItem: {},
      selectedStatus: 0,
    }
  },
  methods: {
    modalShow(id, item) {
      this.isShowModal = true
      this.selectedId = id
      this.orderItem = item
      this.selectedStatus = item.status
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BPagination,
    BButton,
    orderDocModal,
    vSelect,
    BBadge,
  },
  setup() {
    const {
      fetchOrders,
      tableColumns,
      perPage,
      currentPage,
      totalOrders,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refOrderListTable,
      refetchData,
      resolveOrderStatusVariant,
    } = useOrdersList()

    const statusOptions = [
      { label: 'Завершен', value: 0 },
      { label: 'В ожидании', value: 1 },
      { label: 'Отказано', value: 2 },
    ]

    const statusTranslate = {
      0: 'Завершен',
      1: 'В ожидании',
      2: 'Отказано',
    }
    return {
      fetchOrders,
      tableColumns,
      perPage,
      currentPage,
      totalOrders,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refOrderListTable,
      resolveOrderStatusVariant,
      statusTranslate,
      refetchData,
      statusOptions,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
